import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/landing';
import { SpaFallbackFalsePositivesPost } from './pages/blog-spa-fallback';

/** research.nirvik.ai router scaffold. */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/blog/spa-fallback-false-positives" element={<SpaFallbackFalsePositivesPost />} />
    </Routes>
  );
}
